import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LatLngType } from "@repo/ping-react-js";

export type MapBoundsLiteral = {
  north: number;
  south: number;
  east: number;
  west: number;
};

type PLIInitialState = {
  pliId: string | null;
  buildingId: string | null;

  searchedAddress: string | null;
  searchedLatLng: LatLngType | null;
  searchedCountry: string | null;
  fetchedLookupBuilding: any | null;
  insertPinMode: boolean;
  loadingPinMode: boolean;
  showParcelOutline: boolean;
  showParcelLayer: boolean;
  isUSALocation: boolean | null;
  lookupRequestId: number;

  locationReportBounds: MapBoundsLiteral | null;
};

type SetSearchedDataPayload = {
  latLng: LatLngType;
  address: string;
  country?: string | null;
};

const pliSlice = createSlice({
  name: "pli",
  initialState: {
    pliId: null,
    buildingId: null,
    searchedAddress: null,
    searchedLatLng: null,
    searchedCountry: null,
    fetchedLookupBuilding: null,
    insertPinMode: false,
    loadingPinMode: false,
    showParcelOutline: true,
    showParcelLayer: true,
    isUSALocation: false,
    lookupRequestId: 0,
    locationReportBounds: null,
  } as PLIInitialState,
  reducers: {
    requestLookup: (state) => {
      state.lookupRequestId += 1;
    },
    setIsUsaLocation: (state, action: PayloadAction<boolean | null>) => {
      state.isUSALocation = action.payload;
    },
    setLoadingPinMode(state, action: PayloadAction<boolean>) {
      state.loadingPinMode = action.payload;
    },
    setSearchedData(state, action: PayloadAction<SetSearchedDataPayload>) {
      state.searchedLatLng = action.payload.latLng;
      state.searchedAddress = action.payload.address;
      state.searchedCountry = action.payload.country ?? null;
    },
    setSearchedLatLng(state, action: PayloadAction<LatLngType>) {
      state.searchedLatLng = action.payload;
      state.searchedCountry = null;
    },
    setFetchedLookupBuilding(state, action: PayloadAction<any>) {
      state.fetchedLookupBuilding = action.payload;
    },
    setSearchedAddress: (state, action: PayloadAction<string>) => {
      state.searchedAddress = action.payload;
    },
    setInsertPinMode: (state, action: PayloadAction<boolean>) => {
      state.insertPinMode = action.payload;
    },
    resetParcelOutline: (state) => {
      state.showParcelOutline = true;
    },
    toggleParcelOutline: (state) => {
      state.showParcelOutline = !state.showParcelOutline;
    },
    setParcelOutline: (state, action: PayloadAction<boolean>) => {
      state.showParcelOutline = action.payload;
    },
    toggleParcelLayer(state) {
      state.showParcelLayer = !state.showParcelLayer;
    },
    setPliId: (state, action: PayloadAction<string>) => {
      state.pliId = action.payload;
    },
    setBuildingId: (state, action: PayloadAction<string | null>) => {
      state.buildingId = action.payload;
    },
    setLocationReportBounds: (state, action: PayloadAction<MapBoundsLiteral | null>) => {
      state.locationReportBounds = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

const { actions, reducer } = pliSlice;

export const {
  requestLookup,
  setSearchedData,
  setSearchedLatLng,
  setSearchedAddress,
  setFetchedLookupBuilding,
  setInsertPinMode,
  setLoadingPinMode,
  resetParcelOutline,
  toggleParcelOutline,
  setParcelOutline,
  setPliId,
  setBuildingId,
  setIsUsaLocation,
  setLocationReportBounds,
} = actions;

export default reducer;
